import { SelectAutocompleteProps } from '@argenta/react-ui';

export const filterOption: NonNullable<
  SelectAutocompleteProps<{
    label: string;
    value: string;
  }>['filterOptions']
> = (input, options) => {
  return options.filter((option) => {
    const [postalCode, city] = option.label
      .split(/-(.*)/)
      .map((value) => value.trim().toLowerCase());
    const inputLowerCase = input.toLowerCase();

    return (
      city.startsWith(inputLowerCase) ||
      postalCode.startsWith(inputLowerCase) ||
      option.label.toLowerCase().startsWith(inputLowerCase)
    );
  });
};
